export const storageKeys = {
  preferredLanguage: 'preferredLanguage',
  navigationHistory: 'navigationHistory',
  brandingTerms: 'brandingTerms',
  surveyKey: 'surveyKey',
  surveyUserId: 'surveyUserId'
};

export const permissions = {
  canAccessRisk: 'canAccessRisk',
  isSuperAdmin: 'isSuperAdmin',
  isPartner: 'isPartner,',
  isAdmin: 'isAdmin',
  isManager: 'isManager',
  isUser: 'isUser',
  isListed: 'isListed',
  hasAdminRoles: 'hasAdminRoles',
  hasManagerRoles: 'hasManagerRoles'
};

export const languages = {
  english: 'en',
  spanish: 'es',
  portuguese: 'pt',
  french: 'fr',
  russian: 'ru'
};

export const defaultHomeAddress = '/';
export const defaultModuleBaseAddress = '/';
export const defaultDateTimeFormat = 'h:mm a M/d/yy';
export const defaultDateFormat = 'M/d/yy';

export const toastrSeverity = {
  success: 'success',
  info: 'info',
  warning: 'warn',
  error: 'error'
};

export const surveyKey = 'RpxSurveyKey';
export const surveyCompleteResponseMessage = 'Survey has been completed';
export const agilityRiskVersion = '1.0.304';
